import { getCustomCollectionFilter } from '@/services/angularjs-bridge';
import { logger } from '@/services/logger';
import { DataModelAttribute, Item } from '@/types/DataModel';
import { Organization } from '@/types/Organization';
import { User } from '@/types/User';

export const filterCollection = <TData, >(
    allData: TData[],
    item: Item,
    attribute: DataModelAttribute,
    organization: Organization,
    user: User
) : TData[] => {

    if (allData) {
        const uiCollectionFilterName = attribute.params?.uiCollectionFilter;

        if (uiCollectionFilterName) {
            const uiCollectionFilter = getCustomCollectionFilter<TData>(uiCollectionFilterName);

            if (!uiCollectionFilter) {
                logger.error(`filtering: uiCollectionFilter ${uiCollectionFilterName} for attribute ${attribute.name} was not found.`);
                return allData;
            }

            const filteredCollection = uiCollectionFilter(allData, item, attribute, user, organization);

            // If the filter function doesn't return anything, then we display the collection entries as is.
            if (filteredCollection) {
                return filteredCollection;
            } else {
                return allData;
            }

        }
    }

    return allData;
};
